import React, { useState, useEffect, Fragment } from "react";
import { Table, Input, notification, Form } from "antd";
import ManagementService from "../../services/manageService";
import { useTranslation } from "react-i18next";
import "./style.scss";
import UnLock from 'components/UnLock/UnLock';
import { useSelector } from 'react-redux';
import EditableRow from 'components/EditableRow';
import EditableCell from 'components/EditableCell';
import BasicTablePaging from "components/BasicTablePaging/BasicTablePaging";
import { NORMAL_COLUMN_WIDTH } from "constants/app";
import { getAllPermissionFormatArray } from "constants/permission";
import { ROLE_ID_DIRECTOR } from "constants/permission";
import { EXTRA_EXTRA_BIG_COLUMND_WITDTH } from "constants/app";
import { MIN_COLUMN_WIDTH } from "constants/app";
import { VERY_BIG_COLUMN_WIDTH } from "constants/app";
import { BIGGER_COLUMN_WIDTH } from "constants/app";
import { LAYOUT } from "constants/layout";

const PermissionEmployee = () => {
  const { t: translation } = useTranslation();
  const [data, setData] = useState([]);
  const setting = useSelector((state) => state.setting);
  const [form] = Form.useForm();
  const DEFAULT_FILTER = {
    filter: {},
    skip: 0,
    limit: 20,
  }
  const [dataFilter, setDataFilter] = useState(DEFAULT_FILTER)
  const fetchData = (param) => {
    ManagementService.getLists(param).then((result) => {
      if (result) {
        setData(result.data || []);
      }
    });
  };

  const handleUpdatePer = (appUserId, permissionList) => {
    const newParam = {
      id : appUserId,
      data : {
        permissions : permissionList.join(",")
      }
    }
    ManagementService.UpdatePermission(newParam).then((result) => {
      if (result) {
        fetchData();
        notification.success({
          message: '',
          description: translation('accreditation.updateSuccess'),
        })

      } else {
        notification.success({
          message: '',
          description: translation('accreditation.updateError'),
      })
    }})
  };

  useEffect(() => {
    fetchData();
  }, []);
  const handleChangePage = (pageNum) => {
    const newFilter = {
      ...dataFilter,
      skip : (pageNum -1) * dataFilter.limit
    }
    setDataFilter(newFilter)
    fetchData(newFilter)
  }
  const components = {
    body: {
      row: (props) => <EditableRow {...props} form={form} />,
      cell: (props) => <EditableCell {...props} form={form} />,
    },
  };

  const allPermission = getAllPermissionFormatArray();
  const arrayRenderPermission = allPermission.map(item => {
    return {
      title: (
        <div className="check-box">
          {item?.label}
        </div>
      ),
      width: LAYOUT.columns.medium,
      align: "center",
      render: (_, record) => {
        const { permissions, appUserId } = record;
        const permissionValue = item?.value;
        const isChecked = permissions.indexOf(permissionValue) > -1;
        return (
          <div className="check-box">
            <Input
              disabled= {record?.appUserRoleId === ROLE_ID_DIRECTOR}
              checked={record?.appUserRoleId === ROLE_ID_DIRECTOR ? true : isChecked}
              type="checkbox"
              style={{maxWidth:'16px'}}
              name={permissions}
              onChange={() => {
                let permissionList = permissions.split(",");
                if (isChecked) {
                  permissionList = permissionList.filter(
                    (_item) => _item !== permissionValue);
                } else {
                  permissionList.push(permissionValue);
                }
                handleUpdatePer(appUserId, permissionList)

                // call API update role
                // nếu thành công thì call API get
                // nếu thất bại thì thông báo lỗi
              }}
            />
          </div>
        );
      },
    }
  })

  const columns = [
    {
      title: "",
      key: "appUserRoleName",
      dataIndex: "appUserRoleName",
      width: LAYOUT.columns.xlarge,
      align: "center",
      render: (_, record) => {
        const { username } = record;
        return (
          <div className='checks fw-bold'>
            {username}
          </div>
        );
      },
    },
    {
      title: "",
      key: "appUserRoleName",
      dataIndex: "appUserRoleName",
      align: "center",
      width: LAYOUT.columns.large,
      render: (_, record) => {
        return (
          <div className='checks fw-bold'>
            {record?.appUserRoleName}
          </div>
        );
      },
    },
    ...arrayRenderPermission
  ];

  return (
    <Fragment>
    {setting.enableManagerMenu === 0 ? <UnLock /> :
    <div className="">
      <Table
        dataSource={data || []}
        columns={columns}
        scroll={{ x: 1250 }}
        pagination={false}
        bordered={true}
        components={components}
        tableLayout="fixed"
      />
        <BasicTablePaging handlePaginations={handleChangePage} skip={dataFilter.skip} count={data?.length < dataFilter.limit}></BasicTablePaging>
    </div>
    }
    </Fragment>
  );
};

export default PermissionEmployee;
